<script setup lang="ts">
defineProps<{
  product: SingleProduct;
}>();
</script>

<template>
  <div class="relative pb-20 pt-8 xs:pb-56 xs:pt-20">
    <div class="mx-10 flex flex-col gap-4 text-center">
      <h1 class="font-headline text-4xl font-light xs:text-[3.125rem]" v-text="product.title" />
      <div
        v-if="product.intro"
        class="font-base mx-auto max-w-lg xs:text-[1.625rem]"
        v-html="product.intro"
      />
    </div>

    <UiProductsInfoCardList :product="product" />
  </div>
</template>
